<template>
    <div
        id="app"
        class="container-page"
        :class="`page--${$route.name}`">
        <top-navigation v-if="$route.meta.hasTopNavigation !== false"/>
        <div class="container-main-content">
            <main
                id="main-content"
                class="main-content"
                :class="`main-content--${$route.name}`">
                <router-view/>
            </main>
        </div>
        <Footer />

        <CookiesBanner />
    </div>
</template>

<script>
// @ is an alias to /src

import TopNavigation from "@/components/top-navigation/TopNavigation.vue";
import Footer from "@/components/footer/Footer.vue";
import CookiesBanner from "@/components/cookies-banner/CookiesBanner.vue";

import { cleanLocale } from "@/utils/helpers/translation/translation.js";
import { capitalize } from "@/utils/helpers/string.js";

export default {
    name: "Zebrapad",
    components: {
        TopNavigation: TopNavigation,
        Footer: Footer,
        CookiesBanner: CookiesBanner
    },
    computed: {
        lang() {
            return cleanLocale(this.$i18n.locale);
        }
    },
    metaInfo() {
        return {
            title: `${capitalize(this.$appName)} ${(this.$route.name) ? "-" : ""} ${capitalize(this.$t(this.$route.name))}`,
            htmlAttrs: {
                lang: this.lang,
            },
            meta: [
                {
                    name: "description",
                    content: this.$t("site-description")
                }
            ]
        };
    },
    mounted() {
    },
    methods: {
    }
};
</script>
